// Unpublished Work © 2026 Deere & Company.

import React from 'react';
import {Link} from '@deere/isg.component-library';
import {SocialLinks} from './SocialLinks';
import {getFooterData} from '../../../helpers/get-footer-data';
import {translationStore} from '../../../stores/translation-store';
import {useTheme} from '@deere/isg.component-library';

export const PageFooter = ({isMobile}: {isMobile: boolean}): React.ReactElement => {
    const footerData = getFooterData(window.navigator.language);
    const theme = useTheme();

    return (
        <footer className='flex flex-col items-center bg-[#e5e5e5] font-[open-sans,serif] gap-4 p-4 pb-8'>
            <div className='flex flex-wrap flex-row items-center justify-center gap-x-4 gap-y-2 p-0'>
                {footerData.utilityLinks?.map((item: Record<string, string>, index: number) => (
                    <div className='flex-none grow-0' key={`${item.label}-${index}`}>
                        <Link
                            style={{
                                color: '#666',
                                fontSize: '12px',
                                fontWeight: 400,
                                lineHeight: '24px',
                                fontFamily: theme.jddcTokens.JddcTypographyBodyFontFamily,
                                textDecorationColor: '#666'
                            }}
                            href={item.url}
                        >
                            {item.label}
                        </Link>
                    </div>
                ))}
            </div>
            <div
                className='text-[#666] text-xs font-normal leading-6 my-3 text-center'
                style={{
                    fontFamily: theme.jddcTokens.JddcTypographyBodyFontFamily
                }}
            >
                {footerData.copyrightLine}
            </div>
            <SocialLinks links={footerData.socialLinks ?? []} />
            {isMobile && (
                <div className='text-center'>
                    <p className='text-[#666] text-xs my-3'>{translationStore.APPLE_BADGE_LEGAL}</p>
                    <p className='text-[#666] text-xs my-3'>{translationStore.GOOGLE_PLAY_BADGE_LEGAL}</p>
                </div>
            )}
        </footer>
    );
};
